import { useEffect, useState } from "react";
import api from "@/lib/api";
import EventCard from "@/components/EventCard";
import EmptyState from "@/components/EmptyState";
import { Search, Calendar, BadgeCheck } from "lucide-react";

const CATEGORIES = ["Tous", "Concert", "Festival", "Conférence"];

export default function EventsListPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState("Tous");
  const [q, setQ] = useState("");
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (cat !== "Tous") params.category = cat;
    if (q.trim()) params.q = q.trim();
    if (verifiedOnly) params.verified_only = true;
    api.get("/events", { params })
      .then((r) => setEvents(r.data))
      .finally(() => setLoading(false));
  }, [cat, q, verifiedOnly]);

  return (
    <div className="z-container" data-testid="events-list-page">
      <h1 className="z-page-title">Explorez les événements</h1>
      <p className="z-page-sub">Tous les événements publics — réservez sans compte ou créez le vôtre.</p>

      <div style={{ position: "relative", marginBottom: 16 }}>
        <Search size={18} style={{ position: "absolute", left: 14, top: 14, color: "var(--z-muted)" }} />
        <input
          className="z-input" style={{ paddingLeft: 42 }} value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Rechercher par titre, lieu, mot-clé…"
          data-testid="events-search-input"
        />
      </div>

      <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 8, marginBottom: 20, alignItems: "center" }}>
        {CATEGORIES.map((c) => (
          <button
            key={c} onClick={() => setCat(c)}
            data-testid={`category-${c}`}
            className={`z-chip ${cat === c ? "z-chip-active" : ""}`}
          >{c}</button>
        ))}
        <button
          onClick={() => setVerifiedOnly((v) => !v)}
          data-testid="filter-verified-only"
          className={`z-chip ${verifiedOnly ? "z-chip-active" : ""}`}
          style={{ display: "inline-flex", alignItems: "center", gap: 4, whiteSpace: "nowrap" }}
          title="Afficher uniquement les organisateurs certifiés"
        >
          <BadgeCheck size={13} /> Certifiés
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <span className="z-loader z-loader-dark" />
        </div>
      ) : events.length === 0 ? (
        <EmptyState
          icon={<Calendar size={28} />}
          title="Aucun événement trouvé"
          message="Essayez d'élargir vos critères de recherche."
          testId="events-empty"
        />
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 18 }} data-testid="events-grid">
          {events.map((e) => <EventCard key={e.id} event={e} />)}
        </div>
      )}
    </div>
  );
}
